import React from 'react';
import Button from '../../../components/UI/Button/Button';
import FormGrid from '../../../components/UI/FormGrid/FormGrid';
import Textarea from '../../../components/UI/Textarea/Textarea';
import Aux from '../../../hoc/Auxi/Auxi';
import { Alert } from 'react-bootstrap';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

/**
* @desc RecruiterComments in candidate profile section
* @param props
* @return RecruiterComments
*/
const RecruiterComments = (props) => {
  const updateText = props.commentsActive =="updated" ? "Updated" : "Update";
  const inValid = props.errorMsg !== null && props.errorPosition === "RecruiterComments";
  const disabled = props.commentsActive =="update" ? 'disabled' : "";
  return (
    <Aux>
      <FormGrid>
        <div className="title-under-line"></div>
        <Textarea
          className="profile-edit__comments_textarea" 
          placeholder="" 
          name="textarea" 
          value={(props.recruiter_comments && props.recruiter_comments !== null) ? props.recruiter_comments : ""}
          onChange={props.handleRecruiterCommentChange}
          inValid={inValid?"Invalid":""}
          errorMsg={(inValid) ? props.errorMsg: null}
          onBlur={(event)=>props.handleOnBlur(event,"Please provide Recruiter Comments","RecruiterComments")}/>
      </FormGrid>
      <div className="profile-edit__section__buttons">
        <Button 
          className={props.commentsActive} 
          disabled={disabled} 
          onClick={(event)=>props.handleUpdateProfile(event,"commentsActive")}
        >{updateText}</Button>
      </div>
    </Aux>
  );
}

export default RecruiterComments;



// WEBPACK FOOTER //
// ./src/components/Recruiter/RecruiterComments/RecruiterComments.js